import { TFunction } from 'react-i18next';
import { CatalogSettings } from './Settings';
import { CatalogFileSources } from './FileSources';
import { CatalogOnlineSources } from './OnlineSources';
import { CatalogTeamSharingSettings } from './TeamSharingSettings';
import { CatalogPreviewChat } from './PreviewChat';

const routeBase = `/knowledge/:catalogId`;

export const getCatalogDetailSubroutes = (catalogId: string) => {
  const baseUrl = `/knowledge/${catalogId}`;

  return {
    settings: {
      label: (t: TFunction) => t('Knowledge Catalog Settings'),
      component: CatalogSettings,
      exact: true,
      icon: 'cogs-light' as const,
      path: baseUrl,
      routePath: routeBase,
      hideForDefault: false,
    },
    fileSources: {
      label: (t: TFunction) => t('File Sources'),
      component: CatalogFileSources,
      exact: true,
      icon: 'file' as const,
      path: `${baseUrl}/file-sources`,
      routePath: `${routeBase}/file-sources`,
      hideForDefault: false,
    },
    onlineSources: {
      label: (t: TFunction) => t('Online Sources'),
      component: CatalogOnlineSources,
      exact: false,
      icon: 'globe' as const,
      path: `${baseUrl}/online-sources`,
      routePath: `${routeBase}/online-sources`,
      hideForDefault: false,
    },
    teamSharing: {
      label: (t: TFunction) => t('Team Sharing Settings'),
      component: CatalogTeamSharingSettings,
      exact: true,
      icon: 'share-alt' as const,
      path: `${baseUrl}/team-sharing`,
      routePath: `${routeBase}/team-sharing`,
      hideForDefault: true,
    },
    previewChat: {
      label: (t: TFunction) => t('Preview Chat'),
      component: CatalogPreviewChat,
      exact: true,
      icon: 'message-check' as const,
      path: `${baseUrl}/preview-chat`,
      routePath: `${routeBase}/preview-chat`,
      hideForDefault: false,
    },
  };
};
